import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { defineComponent, openBlock, createBlock, unref, isRef, withCtx, createElementVNode, normalizeClass, createVNode, renderSlot, createElementBlock, Fragment, renderList, createCommentVNode } from 'vue';
import { useModelValue } from '../vc-utils';
import { Drawer, Divider } from 'ant-design-vue';
import { useStyleConfig } from '../abstract';
import ThemeEditor from '../theme-provider/ThemeEditor.js';
import ImgCheckbox, { ImgCheckboxGroup } from '../img-checkbox';
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'SettingPanel',
  props: {
    visible: Boolean,
    theme: String,
    presetList: Array
  },
  emits: ["update:visible", "themeSelect", "update:theme"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useStyleConfig = useStyleConfig('setting-panel'),
      prefixCls = _useStyleConfig.prefixCls;
    var _useModelValue = useModelValue(function () {
        return props.visible;
      }, function (val) {
        return emit('update:visible', val);
      }),
      _visible = _useModelValue.value;
    if (props.theme) {
      emit('themeSelect', props.theme);
    }
    var _useModelValue2 = useModelValue(function () {
        return props.theme;
      }, function (val) {
        emit('themeSelect', val);
        emit('update:theme', val);
      }),
      _theme = _useModelValue2.value;
    return function (_ctx, _cache) {
      return openBlock(), createBlock(unref(Drawer), {
        visible: unref(_visible),
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return isRef(_visible) ? _visible.value = $event : null;
        }),
        placement: "right",
        width: 640,
        closable: false
      }, {
        default: withCtx(function () {
          var _props$presetList;
          return [createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls)))
          }, [createVNode(ThemeEditor, null, {
            default: withCtx(function () {
              return [renderSlot(_ctx.$slots, "themeEditorTab")];
            }),
            _: 3 /* FORWARDED */
          }), createVNode(unref(Divider)), createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls), "-preset-list-title"))
          }, "预设主题", 2 /* CLASS */), ((_props$presetList = __props.presetList) === null || _props$presetList === void 0 ? void 0 : _props$presetList.length) > 0 ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass("".concat(unref(prefixCls), "-preset-list"))
          }, [createVNode(unref(ImgCheckboxGroup), {
            class: normalizeClass("".concat(unref(prefixCls), "-preset-list-item")),
            modelValue: unref(_theme),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return isRef(_theme) ? _theme.value = $event : null;
            })
          }, {
            default: withCtx(function () {
              return [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.presetList, function (theme) {
                return openBlock(), createBlock(unref(ImgCheckbox), {
                  width: 96,
                  value: theme.key,
                  title: theme.title,
                  src: theme.imgUrl
                }, null, 8 /* PROPS */, ["value", "title", "src"]);
              }), 256 /* UNKEYED_FRAGMENT */))];
            }),

            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["class", "modelValue"])], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */)];
        }),

        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["visible"]);
    };
  }
});
var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var SettingPanel = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/setting-panel/SettingPanel.js"]]);
export { SettingPanel as default };